<!-- GENERIC ALERT IF MAIN SITE IS NOT SELECTED -->
<div class="grid mb-2">
	<!-- HIDDEN IF IS SHARED SITE -->
	<div *ngIf="currentSite?.CurrentlyOwned" [class]="actionLayout('left')">
		<p-button id="buttonManageThGroups" label="{{ 'MANAGE_THS_GROUPS' | translate }}" (click)="manageThGroups()"
			[disabled]="currentSite === undefined || !currentSite.CurrentlyOwned || thOwnedGroups === undefined || thOwnedGroups.length < 1"
			icon="pi cm-termo" [rounded]="false" [text]="true" severity="primary"
			styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<!-- <div [class]="actionLayout('center')" class="flex justify-content-center">
		<p-button id="buttonReloadThGroups" label="{{ 'RELOAD' | translate }}"
			(click)="reloadFromServer()" [disabled]="currentSite === undefined" icon="pi cm-reload"
			[rounded]="false" [text]="true"
			severity="secondary" styleClass="font-bold border-0">
		</p-button>
	</div> -->
	<!-- NO SITE SELECTED ALERT -->
	<div *ngIf="currentSite === undefined" class="col-12 py-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<i class="pi cm-alert text-lg text-yellow-700"></i>
			<p-tag [value]="('NO_SITE_DEVICE_ALERT' | translate)" severity="warning" styleClass="text-lg"></p-tag>
		</div>
	</div>
	<!-- SHARED SITE ALERT -->
	<div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12 pt-0">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="'SHARED_SITE' | translate" styleClass="p-tag-purple"></p-tag>
		</div>
	</div>
</div>
<!-- THs -->
<div *ngFor="let ownGroup of thOwnedGroups let i = index">
	<div *ngIf="thGroupIsMatchedWithCurrentSite(ownGroup) || thGroupIsUnmatchedWithAllSites(ownGroup) && (currentSite !== undefined && currentSite.CurrentlyOwned)"
		class="grid mb-4">
		<div id="headerThGroup" class="col-12 flex align-items-center"
			[class]="thGroupIsUnmatchedWithCurrentSite(ownGroup) || thGroupIsUnmatchedWithAllSites(ownGroup) ? 'py-0' : ''"
			[ngClass]="siteIsCurrentlyOwned() ? 'justify-content-between' : 'justify-content-center'">
			<div *ngIf="siteIsCurrentlyOwned()" style="width: 5rem;"></div>
			<div class="flex text-center text-lg font-semibold">{{ 'GROUP' | translate }}: {{ ownGroup.name }}</div>
			<div *ngIf="siteIsCurrentlyOwned()" class="flex gap-3">
				<p-button id="groupThShare" [disabled]="thGroupIsUnmatchedWithCurrentSite(ownGroup) || thGroupIsUnmatchedWithAllSites(ownGroup)"
					pTooltip="{{ 'SHARE_GROUP_TH' | translate }}" tooltipPosition="bottom" icon="pi cm-share" [rounded]="false"
					[text]="true" severity="secondary" (click)="share(ownGroup)">
				</p-button>
				<p-button id="groupThShareFinalUsers" [disabled]="thGroupIsUnmatchedWithCurrentSite(ownGroup) || thGroupIsUnmatchedWithAllSites(ownGroup)"
					pTooltip="{{ 'ENABLED_USERS' | translate }}" tooltipPosition="bottom"
					icon="pi cm-users" [rounded]="false" [text]="true" severity="secondary" (click)="finalUsers(ownGroup)">
				</p-button>
			</div>
		</div>
		<!-- MISMATCH NOTES TH GROUP -->
		<div *ngIf="thGroupIsUnmatchedWithCurrentSite(ownGroup) || thGroupIsUnmatchedWithAllSites(ownGroup)"
			class="col-12 pt-0 pb-1 flex-column">
			<div class="flex align-items-center justify-content-center">
				<i class="pi cm-alert text-red-700"></i>
				<p-tag [value]="('NOTE_MISMATCH_THGROUP_SITE' | translate)" severity="danger" styleClass="surface-800 py-1"></p-tag>
			</div>
			<div class="flex align-items-center justify-content-center">
				<i class="pi cm-share text-red-700"></i>
				<p-tag [value]="('NOTE_THGROUP_SITE_ASSOCIATE_FOR_SHARE' | translate)" severity="danger" styleClass="surface-800 py-1"></p-tag>
			</div>
		</div>
		<div class="col-12 pt-0">
			<div class="card border-round px-0 pt-0">
				<p-avatar [style]="getBgColorSchedule(ownGroup)"
					class="flex mx-auto mb-2 w-20rem h-1rem border-round border-noround-top">
				</p-avatar>
				<p-treeTable [value]="groupTrees[ownGroup._id]" [scrollable]="false" [rows]="20" [paginator]="true"
					[loading]="loading" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
					[showCurrentPageReport]="true" [rowHover]="true" (onNodeExpand)="onDeviceExpand($event)"
					(onNodeCollapse)="onDeviceCollapse($event)">
					<ng-template pTemplate="header" let-columns>
					</ng-template>
					<ng-template pTemplate="body" let-rowNode let-columns="columns">
						<div class="grid m-0">
							<tr [ttRow]="rowNode" (click)="selectDevice(rowNode, rowNode.node.data.id)" class="col-12 p-0"
								[class]="rowClass(rowNode)">
								<div *ngIf="!isInThisSite(rowNode)" class="col-12 pb-0">
									<td class="flex align-items-center justify-content-center gap-2">
										<i class="pi cm-alert text-red-700"></i>
										<div class="text-red-700 text-sm">{{ 'NOTE_MISMATCH_TH_SITE' | translate }}</div>
									</td>
								</div>
								<!-- We see note device match with currentSite only if his group is not matched -->
								<div *ngIf="isInThisSite(rowNode) && ownGroup.siteId !== currentSite?.Id && ownGroup.siteId === -1"
									class="col-12 pb-0">
									<td class="flex align-items-center justify-content-center gap-2">
										<i class="pi cm-check text-green-700"></i>
										<div class="text-green-700 text-sm">{{ 'NOTE_MATCH_TH_SITE' | translate }}</div>
									</td>
								</div>
								<div class="col-12 pb-0">
									<div class="grid">
										<td class="col-4">
											<div class="flex align-items-center justify-content-start text-left">
												<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
												<i class="pi {{rowNode.node.data.icon}} text-4xl text-primary mr-3"></i>
												<div class="text-xl font-medium" style="white-space: pre-wrap">{{
													getSplitString(rowNode.node.data.name) |
													truncate:[30]}}</div>
											</div>
										</td>
										<td class="col-4 flex align-items-center justify-content-center">
											{{ rowNode.node.data.description }}
										</td>
										<td class="col-2 flex align-items-center justify-content-center">
											<div *ngIf="rowNode.node.children.length > 0" class="flex flex-column">
												<p-badge [value]="rowNode.node.children.length" class="ml-3 -mb-1"
													styleClass="text-sm pt-0"></p-badge>
												<i class="pi cm-device-connected-small text-2xl"></i>
											</div>
										</td>
										<td class="col-2 flex align-items-center justify-content-center">
											<p-tag *ngIf="!onExtendedMobile() && isInThisSite(rowNode)"
												[value]="getStatus(rowNode.node.data.id)"
												[severity]="getStatusColor(rowNode.node.data.id)"></p-tag>
											<p-tag *ngIf="onExtendedMobile() && isInThisSite(rowNode)" styleClass="p-tag-mobile"
												[severity]="getStatusColor(rowNode.node.data.id)"></p-tag>
										</td>
									</div>
								</div>
							</tr>
						</div>
					</ng-template>
					<ng-template pTemplate="emptymessage" let-columns>
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
				</p-treeTable>
			</div>
		</div>
	</div>
</div>
<div *ngFor="let sharedGroup of thSharedGroups let i = index">
	<!-- just in case.. a shared group need to be inside and matched with currentSite ever -->
	<div *ngIf="thGroupIsMatchedWithCurrentSite(sharedGroup)" class="grid mb-6">
		<div id="headerThGroup" class="col-12 flex align-items-center justify-content-center">
			<div class="flex text-center text-lg font-semibold">{{ 'GROUP' | translate }}: {{ sharedGroup.name }}</div>
		</div>
		<div class="col-12 pt-0">
			<div class="card border-round px-0 pt-0">
				<p-avatar [style]="getBgColorSchedule(sharedGroup)"
					class="flex mx-auto mb-2 w-20rem h-1rem border-round border-noround-top">
				</p-avatar>
				<p-treeTable [value]="groupTrees[sharedGroup._id]" [scrollable]="false" [rows]="20" [paginator]="true"
					[loading]="loading" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
					[showCurrentPageReport]="true" [rowHover]="true" (onNodeExpand)="onDeviceExpand($event)"
					(onNodeCollapse)="onDeviceCollapse($event)">
					<ng-template pTemplate="header" let-columns>
					</ng-template>
					<ng-template pTemplate="body" let-rowNode let-columns="columns">
						<div class="grid m-0">
							<tr [ttRow]="rowNode" (click)="selectDevice(rowNode, rowNode.node.data.id)" class="col-12 p-0"
								[class]="rowClass(rowNode)">
								<div class="col-12 pb-0">
									<div class="grid">
										<td class="col-4">
											<div class="flex align-items-center justify-content-start text-left">
												<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
												<i class="pi {{rowNode.node.data.icon}} text-4xl text-primary mr-3"></i>
												<div class="text-xl font-medium" style="white-space: pre-wrap">{{
													getSplitString(rowNode.node.data.name) |
													truncate:[30]}}</div>
											</div>
										</td>
										<td class="col-4 flex align-items-center justify-content-center">
											{{ rowNode.node.data.description }}
										</td>
										<td class="col-2 flex align-items-center justify-content-center">
											<div *ngIf="rowNode.node.children.length > 0" class="flex flex-column">
												<p-badge [value]="rowNode.node.children.length" class="ml-3 -mb-1"
													styleClass="text-sm pt-0"></p-badge>
												<i class="pi cm-device-connected-small text-2xl"></i>
											</div>
										</td>
										<td class="col-2 flex align-items-center justify-content-center">
											<p-tag *ngIf="!onExtendedMobile() && isInThisSite(rowNode)"
												[value]="getStatus(rowNode.node.data.id)"
												[severity]="getStatusColor(rowNode.node.data.id)"></p-tag>
											<p-tag *ngIf="onExtendedMobile() && isInThisSite(rowNode)" styleClass="p-tag-mobile"
												[severity]="getStatusColor(rowNode.node.data.id)"></p-tag>
										</td>
									</div>
								</div>
							</tr>
						</div>
					</ng-template>
					<ng-template pTemplate="emptymessage" let-columns>
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
				</p-treeTable>
			</div>
		</div>
	</div>
</div>